export default function SectionHeader({ title, subtitle, align = 'center' }) {
  const alignmentClass =
    align === 'left'
      ? 'text-left'
      : align === 'right'
        ? 'text-right'
        : 'text-center'

  return (
    <div className={`mx-auto max-w-2xl ${alignmentClass}`}>
      <h1 className="font-serif text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl leading-tight">
        {title}
      </h1>
      {subtitle && <p className="subheading mt-4">{subtitle}</p>}
    </div>
  )
}
